import React, { useEffect, useState } from 'react';
import { Produit, getProduits } from '../services/apiProduits';
import { CardProduit } from 'components/CardProduit';
import { Title } from 'components/base/Title';
import Section from 'components/base/Section';
import { handleApiError } from 'utils/errorHandlers';
import { ApiLoading } from 'components/ApiLoading';

export const Produits: React.FC = () => {
  const [produits, setProduits] = useState<Produit[]>([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState<Record<string, string[]>>({});

  useEffect(() => {
    const fetchProduits = async () => {
      try {
        const data = await getProduits();
        setProduits(data);
      } catch (error: any) {
        setErrors(handleApiError(error));  
      } finally {
        setLoading(false);
      }
    };

    fetchProduits();
  }, []);

  if (errors && errors.general) {
    return <ApiLoading type="error">{errors.general[0]}</ApiLoading>;
  }

  if (loading) {
    return <ApiLoading type="loading">Chargement des produits...</ApiLoading>;
  }

  if (produits.length === 0) {
    return <ApiLoading type="no-data">Aucun produit trouvé</ApiLoading>;
  }

  return (
    <Section>
      <Title type='display' centered className='mb-4'>Nos Produits</Title>
      <div className='grid gap-6
          grid-cols-1
          md:grid-cols-2
          justify-items-center'>
        {produits.map((produit) => {
          return (
            <CardProduit key={produit.id} 
              produit={produit}
            />
          );
        })}
      </div>
    </Section>
  );
};